import type { TutorAttendanceRatesStore } from './interfaces'

import { isFullArray } from '@helpers/array'

export const getters = {
  isLoading: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['loading'] => state.loading,
  getRates: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['rates'] => state.rates,
  hasRates: (state: TutorAttendanceRatesStore): boolean => isFullArray(state.rates),
  getTotals: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['totals'] => state.totals,
  getMeta: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['meta'] => state.meta,
  getFilters: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['filters'] => state.filters,
  getCurrentPage: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['currentPage'] => state.currentPage,
  getPerPage: (state: TutorAttendanceRatesStore): TutorAttendanceRatesStore['perPage'] => state.perPage,
}
